import React from "react";
import ReactDOM from "react-dom";
import "shared/styles/app.scss";

import { App } from "core/App";

const root = document.getElementById("root");

const app = (
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

if (root?.hasChildNodes()) {
    ReactDOM.hydrate(app, root);
} else {
    ReactDOM.render(app, root);
}
